// extracted by mini-css-extract-plugin
module.exports = {"SVelgFilmMaxWidthMovieGrid":"velgfilm_SVelgFilmMaxWidthMovieGrid__z0kmb","SNoMovies":"velgfilm_SNoMovies__dZVd3","SAd":"velgfilm_SAd__fEZaX"};